import { PermissionType } from '@next-space/fe-api-idl';
import { useEffect } from 'react';
import { getPermissions } from 'src/hooks/share/use-permissions';
import { useCurrentSpaceView } from 'src/hooks/space';
import { useUpdateSpaceView } from 'src/hooks/space/use-update-space-view';
import { transaction } from 'src/hooks/use-transaction';
import { useIsLogin } from 'src/hooks/user/use-is-login';
import { removeBlockPermission } from 'src/redux/managers/block/update-permission';
import { WikiManager } from 'src/redux/managers/block/wiki-manager';
import { i18n } from '@flowus/common/i18n';

export const useTryCreatePersonalWiki = () => {
  const isLogin = useIsLogin();
  const spaceView = useCurrentSpaceView();
  const updateSpaceView = useUpdateSpaceView();
  // 初始化个人知识库wiki
  useEffect(() => {
    // 如果已经有就不用了
    if (!isLogin) return;
    if (!spaceView) return;
    const existWikiId = spaceView?.setting.wikiId;
    if (existWikiId) {
      const { shared } = getPermissions(existWikiId);
      if (shared) {
        // 以前的个人知识库默认开启了分享，这里给关掉
        transaction(() => {
          removeBlockPermission(existWikiId, { type: PermissionType.PUBLIC });
        });
      }
      return;
    }
    const wikiId = WikiManager.createWiki(i18n.t('common.personal_wiki'), '', undefined, true);
    transaction(() => {
      updateSpaceView(spaceView.uuid, {
        setting: {
          wikiId,
        },
      });
    });
  }, [isLogin, spaceView, updateSpaceView]);
};
